import { render, staticRenderFns } from "./EnderecoCobranca.vue?vue&type=template&id=389c1c7c&"
import script from "./EnderecoCobranca.vue?vue&type=script&lang=js&"
export * from "./EnderecoCobranca.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoCobranca.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EnderecoCobranca.vue"
export default component.exports